$(document).on("click",".newsroom_slider_main_wrap .slick-next",function(){
window.dispatchEvent(new Event('resize'));
});
$(document).on("click",".newsroom_slider_main_wrap .slick-prev",function(){
window.dispatchEvent(new Event('resize'));
});


setTimeout(function() {
var get_url = window.location.href;    

if(get_url.includes('#portfolio_main_page')){
    $("li.test--1 input[data-handle='all-brands']").prop('checked',false);

console.log('animated');
 $('html, body').animate({
        scrollTop: $("#portfolio_main_page").offset().top
    }, 0);
}
}, 400);
document.onreadystatechange = function () {
  var state = document.readyState
  if (state == 'complete') {
      setTimeout(function(){
          document.getElementById('interactive');
         document.getElementById('load').style.display="none";
      },1000);
  }
}
function custom_accordions_for_mobile(){
  $(".accordions_block_custom  > .only_mobile_accordions").on("click", function() {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this)
        .siblings(".footer_mobile_accordion_content")
        .slideUp(200);
    } else {
      $(".accordions_block_custom > .only_mobile_accordions").removeClass("active");
      $(this).addClass("active");
      $(".footer_mobile_accordion_content").slideUp(200);
      $(this)
        .siblings(".footer_mobile_accordion_content")
        .slideDown(200);
    }
  });
} 
$(function(){
  

// $("#custom-brands").hover(function() {
// var vislength = $('.animate-left.animate-work:visible').length;
//   if(vislength == 0){
//     $('.animate-left').toggle('slide', { direction: 'left' }, 500);
//     $('.animate-right').toggle('slide', { direction: 'right' }, 500);
//       setTimeout(function(){ 
//     $('.brand_menus.leftslide').hide();
//     $('.brand_menus.leftslide').css("opacity","1");         
//     $(".brand_menus.leftslide").slideDown(400);
//     $('.animate-left').addClass("animate-work");
        
//       }, 500);
//   }
//         }, function() {
 
//   var vislength = $('.animate-left:visible').length;
//   if(vislength == 1){
//     //$('.brand_menus.leftslide').css("opacity","0");         
  
//   $('.animate-left').toggle('slide', { direction: 'left' }, 500);
//   $('.animate-right').toggle('slide', { direction: 'right' }, 500);
//   $(".brand_menus.leftslide").slideUp(400);    
//  $('.animate-left').removeClass("animate-work");
 
//   }
//         });


$("#custom-brands").mouseenter(function () {
    $(this).parent().addClass("result_hover");
    $('.brand_menu_main').css('visibility','visible');
  $('.animate-right').addClass("new");
    $('.animate-left').addClass("new");
$('.brand_menus.leftslide').addClass("new1");
 }).mouseleave(function () {
    $(this).parent().removeClass("result_hover");
    $('.animate-right').removeClass("new");
    $('.animate-left').removeClass("new");
     //$('.brand_menus.leftslide').removeClass("new1");
     $('.brand_menus.leftslide').removeClass("new1");  
// $('.brand_menu_main').hide('2000');
   $('.brand_menu_main').css('visibility','hidden');
  });

  
  $(document).ready(function() {
    
// $('.search_bar_inner_customn input').on('blur', function(){
//    $(this).parent().addClass('input-desc');
// }).on('focus', function(){
//   $(this).parent().removeClass('input-desc').addClass('input-desc-hover');
// });
var get_width = $(window).width();
if(get_width < 989){
$('.custom_template_newsroom .newsroom-wrap .owl-carousel-news-slider').owlCarousel('destroy');
}
//   var $slider = $('.relatedArticles.for_mobile_slider');
//   var $progressBar = $('.progress');
//   var $progressBarLabel = $( '.slider__label' );
  
//   $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {   
// nextSlide = nextSlide + 1;
//     var calc = ( (nextSlide) / (slick.slideCount-1) ) * 100;
//     $progressBar
//       .css('background-size', calc + '% 100%')
//       .attr('aria-valuenow', calc );
    
//     $progressBarLabel.text( calc + '% completed' );
//   });
//   $slider.slick({
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     infinite: true,
//     arrows: true,
//     dots: false,
//     centerMode: true,
//     speed: 400,
//       infinite: false

//   });  
});
  
  $('.brand_slides').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 5,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});

// $(".owl-carousel-brand-slider,.owl-carousel-news-slider").owlCarousel({
//                 left: true,
//                 items: 3.9,
//                 loop: false,
//                 margin: 50,
//                 nav: true,
//                 dots: false,
//                 touchDrag  : false,
//                 mouseDrag  : false,
//                 responsive: {
//                    800: {
//                         items: 3.65,
//                     },
//                     600: {
//                         items: 1.2,
                      
//                     },
//                   280: {
//                         items: 1.1,
//                       margin: 30,
//                     },
//                 },
//             });


  
 $('.owl-carousel-brand-slider,.owl-carousel-news-slider').owlCarousel({
    margin:25,
    nav:true,
loop: false,
   slideBy: 3, 
    items: 3,
   touchDrag  : false,
   mouseDrag  : false,
  dots: true,
    responsive:{
        0:{
            items: 2,
             mouseDrag: true,
    touchDrag  : true,
           slideBy: 1,
          dotsEach: true
        },
        989:{
            items:2,
             mouseDrag: true,
    touchDrag  : true,
           slideBy: 2
         
        },
        1000:{
            items:3,
             mouseDrag: true,
    touchDrag  : true,
           slideBy: 3,
  margin:25,    
        }
    }
})

 $('.owl-carousel-brand-slider2').owlCarousel({
    margin:25,
    nav:true,
    items: 3,
    slideBy: 3, 
   touchDrag  : false,
   mouseDrag  : false,
      dots: true,
    responsive:{
        0:{
           
          items: 1.75,
       dots: true,
      mouseDrag: true,
           slideBy: 1, 
   touchDrag  : true
          
        },
        600:{
            items:3,
           slideBy: 3, 
           dots: true,
      mouseDrag: true,
    touchDrag  : true
        },
        1000:{
            items:3,
             dots: true,
      mouseDrag: true,
           slideBy: 3, 
    margin:0,

          
    touchDrag  : true
        }
    }
})
 
//   var owl = $('.owl-carousel');
// owl.owlCarousel();
// owl.on('changed.owl.carousel', function(event) {
//    // $('.owl-item:first').addClass('remove_margin');
//   if($(this).find(".owl-prev").hasClass('disabled')){
//    $(this).removeClass('remove_margin');
//    $(this).removeClass('clear_margin');

//   }else{
//    $(this).addClass('clear_margin');

// }

//   if($(this).find(".owl-next").hasClass('disabled')){
//    $(this).addClass('remove_margin');
//   }
//   // setTimeout(function(){
//   // $('.owl-item.active:first').removeClass('remove_margin');
//   // // $('.owl-carousel-brand-slider').removeClass('remove_margin');

//   // },1000);
// });

$('.mobile_brands_d').click(function(){
    $('.brand_menu_mobile').addClass('show_mobile_brands');
});
$('.back_arrow').click(function(){
    $('.brand_menu_mobile').removeClass('show_mobile_brands');
});
  
 if (window.location.href.indexOf("history") > -1) {


   
  $(() => {
    var get_height_header = $(".header-wrapper").height();
    let outer_height = $('#explore_history').offset().top - get_height_header;
  let stickyTop = outer_height,
  scrollTarget = false;
//alert(stickyTop);
  let timeline = $('.timeline__nav'),
  items = $('li', timeline),
  milestones = $('.timeline__section .milestone'),
  offsetTop = parseInt(timeline.css('top'));

  const TIMELINE_VALUES = {
    start: 190,
    step: 30 };

  $(window).resize(function () {
    timeline.removeClass('fixed');

   // stickyTop = timeline.offset().top - offsetTop;

    $(window).trigger('scroll');
  }).trigger('resize');
  $(window).scroll(function () {
    if ($(window).scrollTop() > stickyTop) {
      //    $("nav.timeline__nav.history_common_wrap").show();
      timeline.addClass('fixed');
    } else {
           //  $("nav.timeline__nav.history_common_wrap").hide();
      timeline.removeClass('fixed');
    }
var get_height = $(".history_main_data").height();
var get_header_height = $("sticky-header.header-wrapper").height();
var get_carrer_section_height = $(".careers-at_ca").height();
var get_scroll = $(".careers-at_ca").offset().top - 500;
var get_combined = get_height + get_header_height + get_carrer_section_height;
if($(window).scrollTop() > get_scroll){
     $(".history_common_wrap").addClass('hide_important');
}else{
      $(".history_common_wrap").removeClass('hide_important');

}
  }).trigger('scroll');

  items.find('span').click(function () {
    let li = $(this).parent(),
    index = li.index(),
    milestone = milestones.eq(index);

    if (!li.hasClass('active') && milestone.length) {
      scrollTarget = index;

      let scrollTargetTop = milestone.offset().top - 150;

      $('html, body').animate({ scrollTop: scrollTargetTop }, {
        duration: 0,
        complete: function complete() {
          scrollTarget = false;
        } });

    }
  });

  $(window).scroll(function () {
  var scroll_top =  $(window).scrollTop();
    let viewLine = scroll_top + $(window).height() / 3,
    active = -1;

    if (scrollTarget === false) {
      milestones.each(function () {
          var get_offset_top = $(this).offset().top;
        if (get_offset_top - viewLine > 0) {
          return false;
     
        }
      
        active++;
      });
    } else {
      active = scrollTarget;
    }

    //timeline.css('top', -1 * active * TIMELINE_VALUES.step + TIMELINE_VALUES.start + 'px');

    items.filter('.active').removeClass('active');

    items.eq(active != -1 ? active : 0).addClass('active');
  }).trigger('scroll');

});

 }

  $(".rightside ul li").mouseenter(function() {
     $(".rightside ul li").removeClass('brand_hovered');
    $(this).addClass('brand_hovered');
    //$('.brand_items.hovered .brand_menus.leftslide').css({"transform":"translateX(0)","transition":"all .8s ease","-webkit-transition": "all 0.8s ease"})
})
  //   $(".brand_items").mouseenter(function() {
//     $(this).addClass('hovered');
//     $('.brand_items.hovered .brand_menus.leftslide').css({"transform":"translateX(0)","transition":"all .8s ease","-webkit-transition": "all 0.8s ease"})
// }).mouseleave(function() {
//     $(this).removeClass('hovered');
// });
    custom_accordions_for_mobile();
});

$(document).on("click",".sb_title",function(){
var urls = $(this).attr("date-url");
window.location.href= urls;
  
})
$(document).on("click",".h1-heading",function(){
var urls = $(this).attr("date-url");
window.location.href= urls;
  
});
$(document).on("click",".right-side-link",function(){
var urls = $(this).find("a").attr("href");
window.location.href= urls;

  
});





$(window).on('resize', function(){
    var win = $(this).width(); //this = window
if(win < 989){
$('.custom_template_newsroom .newsroom-wrap .owl-carousel-news-slider').owlCarousel('destroy');
}else{
 $('.owl-carousel-brand-slider,.owl-carousel-news-slider').owlCarousel({
    margin:25,
    nav:true,
    items: 3.45,
   touchDrag  : false,
   mouseDrag  : false,
    responsive:{
        0:{
            items:1.75
        },
        600:{
            items:3
         
        },
        1000:{
            items:4
          
        }
    }
})
}
});

 $(document).on('click','.video_play_pause_wrappper .muted_icon',function(){
$(this).hide();
$(".video_play_pause_wrappper .play_icon").show();   
$(".video-section video").prop("muted", false);
});
 $(document).on('click','.video_play_pause_wrappper .play_icon',function(){
$(this).hide();
$(".video_play_pause_wrappper .muted_icon").show();   
$(".video-section video").prop("muted", true);

});
$(document).ready(function(){


    var get_location = window.location.href;
    if(get_location.includes('#our-company')){
  var get_height = $("sticky-header.header-wrapper").height();
  $('html, body').animate({
        scrollTop: $("#s_our-company").offset().top - get_height - 30
    }, 0);
    }

$(".wrapMulDrop.portfolio_dropdown input").eq(0).prop('checked',true);
        var check_index = 0 ; 
    $(document).on("click",".f_brand_slide",function(e) {

var get_width = $(window).width();
  var $this = $(this);
if(get_width < 769){
 setTimeout(function() {
  if($('body').hasClass('brand_specific_class')){

var get_link = $this.parents('.portfololio_inner_wrap').find('a').attr('href');
   window.location.href= get_link;
  }else if($('body').hasClass('home_parent')){
var get_link = $this.parents('.owl-carousel-brand-slider .owl-item').find('a').attr('href');
    if(typeof get_link != 'undefined' ){
   window.location.href= get_link;
    }
}
}, 1000);
}else{
  if($('body').hasClass('brand_specific_class')){

var get_link = $this.parents('.portfololio_inner_wrap').find('a').attr('href');
   window.location.href= get_link;
  }else if($('body').hasClass('home_parent')){
var get_link = $this.parents('.owl-carousel-brand-slider .owl-item').find('a').attr('href');
    if(typeof get_link != 'undefined' ){
   window.location.href= get_link;
    }
}
}

      check_index ++;      
});
$(".portfolio_menu_title.active").trigger('click');
$("button.submit_btn.green_btn").trigger('click');




});
$(".footer__copyright.caption img").click(function(){
      if($('body').hasClass('home_parent')){
         $("html, body").animate({ scrollTop: 0 }, 0);
     }else{
 window.location.href = '/';
    }
    
});
$(".news.f_brand_slide").click(function(){
var get_link = $(this).parents('.item').find('a').attr('href');
if (typeof get_link != "undefined") {
      //window.location.href = get_link;
window.open(get_link, '_blank');
}
    
});

  $(window).scroll(function () {
      var get_width = $(window).width();
      if(get_width < 769){
      var get_selected = $(".wrapMulDrop.portfolio_dropdown").hasClass('active');
      var get_selected2 = $(".search_and_filter_wrap .wrapMulDrop.brands_filter").hasClass('active');
      var get_selected3 = $(".wrapMulDrop.dates_dropdown").hasClass('active');

      if(get_selected == true){
 $(".wrapMulDrop.portfolio_dropdown").removeClass('active');
      }
      if(get_selected2 == true){
 $(".search_and_filter_wrap .wrapMulDrop.brands_filter").removeClass('active');
      }
      if(get_selected3 == true){
 $("body").addClass('animation_up');
              $("body").removeClass('date_picker_visible');
            $(".wrapMulDrop.dates_dropdown").removeClass('active');
      }
      }
  });
$("li.start_scroll").click(function(){
var get_height = $(".header-wrapper").height() - 100;
$('html, body').animate({
        scrollTop: $("#explore_history").offset().top + get_height
    }, 0);
    
});
// $(".f_brand_slide a").click(function(e){

//     e.preventDefault();
//     e.stopPropagation();
//     var get_href = $(this).attr('href');
//     window.open(get_href, '_blank');
// });

